import UtilsUrl from "../../utils/UtilsUrl";
import api from "../api";



class AbonnementService{

  addAbonnement(abonnementAddModel) {
    return api.post(
      UtilsUrl.AbonnementURL() +
        "/addAbonnement",abonnementAddModel
    );
  }

  getAllAbonnement(idUser,idWarehouse) {
    return api.get(
      UtilsUrl.AbonnementURL() +
        "/getAllAbonnement/"+idUser+"/"+idWarehouse
    );
    
  }
  getAllAbonnementDetails(idUser, idAbonnement) {
    return api.get(
      UtilsUrl.AbonnementURL() +
      "/getAbonnementDetails/" + idUser + "/"+ idAbonnement
      );
    }
  deleteAbonnement(idUser, idAbonnement, activeOrDesactive) {
    return api.put(
      UtilsUrl.AbonnementURL() +
      `/deleteAbonnement/${idUser}/${idAbonnement}/${activeOrDesactive}`
    );
  }
  activeOrDesactiveAbonnement(idUser, idAbonnement, activeOrDesactive) {
    return api.put(
      UtilsUrl.AbonnementURL() +
      `/activeOrDesactiveAbonnement/${idUser}/${idAbonnement}/${activeOrDesactive}`
    );
  }

}export default new AbonnementService();